import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { KeyIdea, DidYouKnow } from "@/components/Callouts";
import { Section } from "@/components/Section";

export default function EdSheeran17() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "17");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section eyebrow="Lesson 17" title="Freedom">
        <YouTubeEmbed videoId="wzH3MHmIWvU" title="Freedom — Ed Sheeran" />
        <NoteImage
          src="/notes/ed-sheeran/finals/17-freedom.png"
          caption="Jason's handwritten chord chart for this lesson."
        />
      </Section>

      <Section eyebrow="Chord analysis" title="C major — a loop that starts on IV">
        {/* Jason's chart (key: C major): intro/chorus F C G Am-G; verse C (C/E) G (Gsus4) Am (G) F(add2); pre Cmaj7/E F Cmaj7/E F */}
        <RomanNumeralAnalysis
          label="Intro & chorus"
          caption="F → C → G → Am G. The loop starts on IV, not on I."
          chords={[
            { chord: "F",  rn: "IV", function: "Pre-dominant", pitches: ["F3","A3","C4","F4"] },
            { bar: true },
            { chord: "C",  rn: "I",  function: "Tonic",        pitches: ["C3","E3","G3","C4"] },
            { bar: true },
            { chord: "G",  rn: "V",  function: "Dominant",     pitches: ["G3","B3","D4","G4"] },
            { bar: true },
            { chord: "Am", rn: "vi", function: "Submediant",   pitches: ["A3","C4","E4","A4"] },
            { chord: "G",  rn: "V",  function: "Dominant",     pitches: ["G3","B3","D4","G4"] },
          ]}
        />
        <KeyIdea title="Starting away from home">
          Jason labels the key C major, and every chord on his chart is diatonic — no sharps or flats anywhere. Because the loop starts on F (IV), the first chord you hear is away from home; C (I) only arrives as the second chord.
        </KeyIdea>
      </Section>
      <Section eyebrow="Takeaway" title="The pre-chorus step">
        <DidYouKnow title="Cmaj7/E → F">
          The pre-chorus swings between Cmaj7/E and F. With E in the bass under Cmaj7, the bass only has to rise a half step, E → F, to reach the next chord — a small move with a big lift.
        </DidYouKnow>
      </Section>
    </LessonShell>
  );
}
